import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import Notification from '../Notification';

const MaintenanceWarning: FC = () => {
  const { t, i18n } = useTranslate();

  const currentDate = new Date();
  const day = currentDate.getDate();

  const getMonthName = (language: string) => {
    const locales: { [key: string]: string } = {
      es: 'es-ES',
      en: 'en-US',
      fr: 'fr-FR',
    };
    const locale = locales[language] || 'es-ES';
    return currentDate.toLocaleString(locale, { month: 'long' });
  };

  const month = getMonthName(i18n.language);

  return (
    <Notification
      id="M-0001"
      title={t('MaintenanceWarningTitle')}
      message={t('MaintenanceWarningMessage', { day, month })}
      type="primary"
      // @ts-ignore
      link="/contacto"
      linkText={t('ContactUs')}
      icon="ni-alert-circle"
      fill={false}
      dismissible={false}
      action={() => {}}
      actionText=""
      actionData={null}
    />
  );
};

export default MaintenanceWarning;
